import {
  CHANGE_TOTAL_PRE_TAX,
  CHANGE_TAX_COST,
  CHANGE_TIP_COST,
  ADD_ITEM,
  REMOVE_ITEM
} from './action-types'

const initialState = {
  totalPreTax: 0,
  taxCost: 0,
  tipCost: 0,
  items: {name: '', price: 0, split: 1, isSplit: false}
}

export default function (state=initialState, action) {
  switch (action.type) {
    case CHANGE_TOTAL_PRE_TAX:
      const { totalPreTax } = action.payload
      return {
        ...state,
        totalPreTax
      }
    case CHANGE_TAX_COST:
      const { taxCost } = action.payload
      return {
        ...state,
        taxCost
      }
    case CHANGE_TIP_COST:
      const { tipCost } = action.payload
      return {
        ...state,
        tipCost
      }
    case ADD_ITEM:
      const { item } = action.payload
      return {
        ...state,
        items: [
          ...state.items,
          {...item}
        ]
      }
    case REMOVE_ITEM:
      const { index } = action.payload
      return {
        ...state,
        items: [
          ...state.items.slice(0, index),
          ...state.items.slice(index + 1)
        ]
      }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/core/receipt/reducer.js
 **/